export interface Job {
  id: string
  title: string
  department: string
  location: string
  type: string
  description: string
  requirements: string[]
}

export const jobs: Job[] = [
  {
    id: 'j1',
    title: 'Técnico de Instalação de CFTV',
    department: 'Operações',
    location: 'Rio de Janeiro, RJ',
    type: 'Efetivo · Presencial',
    description: 'Responsável pela instalação e configuração de sistemas de videovigilância em clientes corporativos.',
    requirements: ['Experiência com câmeras IP e NVRs', 'CNH categoria B', 'Conhecimento em redes básico'],
  },
  {
    id: 'j2',
    title: 'Engenheiro de Projetos de Segurança',
    department: 'Engenharia',
    location: 'Rio de Janeiro, RJ',
    type: 'Efetivo · Híbrido',
    description: 'Elaboração de projetos executivos de sistemas de segurança eletrônica e alarme de incêndio.',
    requirements: ['Formação em Engenharia Elétrica ou similar', 'Conhecimento das normas ABNT', 'Experiência com AutoCAD'],
  },
  {
    id: 'j3',
    title: 'Analista Comercial B2B',
    department: 'Comercial',
    location: 'Rio de Janeiro, RJ',
    type: 'Efetivo · Presencial',
    description: 'Prospecção e atendimento a clientes corporativos, elaboração de propostas técnico-comerciais.',
    requirements: ['Experiência em vendas B2B', 'Boa comunicação e negociação', 'Disponibilidade para viagens'],
  },
  {
    id: 'j4',
    title: 'Técnico de Redes e Telecom',
    department: 'Infraestrutura',
    location: 'Rio de Janeiro, RJ',
    type: 'Efetivo · Presencial',
    description: 'Instalação e manutenção de infraestrutura de redes, cabeamento estruturado e conectividade.',
    requirements: ['Certificação em redes (CCNA desejável)', 'Experiência com cabeamento estruturado', 'Disponibilidade de horário'],
  },
  {
    id: 'j5',
    title: 'Analista de Suporte Técnico',
    department: 'Atendimento',
    location: 'Rio de Janeiro, RJ',
    type: 'Efetivo · Remoto',
    description: 'Suporte técnico remoto a clientes com sistemas de segurança e monitoramento instalados.',
    requirements: ['Experiência em suporte técnico', 'Conhecimento em sistemas de CFTV e alarmes', 'Boa comunicação escrita e verbal'],
  },
]
